import { render, staticRenderFns } from "./GenericReviewList.vue?vue&type=template&id=53d6d3cf"
import script from "./GenericReviewList.vue?vue&type=script&lang=js"
export * from "./GenericReviewList.vue?vue&type=script&lang=js"
import style0 from "./GenericReviewList.vue?vue&type=style&index=0&id=53d6d3cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports